<nav role="navigation" class="navbar-inner" [ngClass]="direction"
  [class.banner-default]="layout.state.bannerState === BannerState.default"
  [class.banner-info]="layout.state.bannerState === BannerState.info"
  [class.banner-important]="layout.state.bannerState === BannerState.important"

  [@openState]="openState"
  [class.dropdown-open]="layout.state.navbarOpen"
  >
  <ul>
    @if (!authService.loggedIn()) {
      <li  class="nav-item signin"
        [class.active]="signinLink.isActive"
        >
        <a class="nav-link"
          routerLink="/signin"
          routerLinkActive
          #signinLink="routerLinkActive"
          [tabindex]="signinLink.active ? -1 : 0"
          >Sign in
          <div class="indicator">►</div>
        </a>
      </li>
    }

    @if (authService.loggedIn()) {
      <li  class="nav-item"
        [class.active]="accountsLink.isActive"
        >
        <a class="nav-link"
          routerLink="/accounts"
          routerLinkActive
          #accountsLink="routerLinkActive"
          [tabindex]="accountsLink.isActive ? -1 : 0"
          >Accounts
          <div class="indicator">►</div>
        </a>
      </li>
    }

    @if (authService.loggedIn()) {
      <li  class="nav-item"
        [class.active]="extCircLink.isActive"
        >
        <a class="nav-link"
          routerLink="/revalidation"
          routerLinkActive
          #extCircLink="routerLinkActive"
          [tabindex]="extCircLink.isActive ? -1 : 0"
          >Revalidation
          <div class="indicator">►</div>
        </a>
      </li>
    }

    @if (authService.loggedIn()) {
      <li  class="nav-item"
        [class.active]="extCircLink.isActive"
        >
        <a class="nav-link"
          routerLink="/notifications"
          routerLinkActive
          #extCircLink="routerLinkActive"
          [tabindex]="extCircLink.isActive ? -1 : 0"
          >Notifications
          <div class="indicator">►</div>
        </a>
      </li>
    }

    <!-- <li *ngIf="authService.loggedIn()"  class="nav-item"
    [class.active]="premisesNotificationsLink.isActive"
    >
    <a class="nav-link"
      routerLink="/premises/notifications"
      routerLinkActive
      #premisesNotificationsLink="routerLinkActive"
      [tabindex]="premisesNotificationsLink.isActive ? -1 : 0"
      >Preimses Notifications
      <div class="indicator">►</div>
    </a>
  </li> -->

  <!-- <li *ngIf="authService.loggedIn()"  class="nav-item"
  [class.active]="extCircLink.isActive"
  >
  <a class="nav-link"
    routerLink="/maintenanceForm"
    routerLinkActive
    #extCircLink="routerLinkActive"
    [tabindex]="extCircLink.active1 ? -1 : 0"
    >Site Content
    <div class="indicator">►</div>
  </a>
</li> -->

<!-- <li ng-show="false" class=".ng-hide"
[class.active]="extCircLink.isActive"
>
<a class="nav-link"
  routerLink="/maintenanceForm"
  routerLinkActive
  #extCircLink="routerLinkActive"
  [tabindex]="extCircLink.active1 ? -1 : 0"
  >Site Content
  <div class="indicator">►</div>
</a>
</li> -->

@if (authService.loggedIn()) {
  <li  class="nav-item"
    [class.active]="applicationsLink.isActive"
    >
    <a class="nav-link"
      routerLink="prereg/applications"
      routerLinkActive
      #applicationsLink="routerLinkActive"
      >Applications
      <div class="indicator">►</div>
    </a>
  </li>
}

@if (authService.loggedIn()) {
  <li  class="nav-item"
    [class.active]="applicationsLink.isActive"
    >
    <a class="nav-link"
      routerLink="queries"
      routerLinkActive
      #applicationsLink="routerLinkActive"
      >Queries
      <div class="indicator">►</div>
    </a>
  </li>
}


<li class="nav-item fill">
</li>

@if (authService.loggedIn()) {
  <li class="nav-item sign signout">
    <a class="nav-link clickable" href="#" (click)="signout()">Sign out
      <div aria-hidden="true" class="indicator">►</div>
    </a>
  </li>
}

<li class="nav-item burger" [class.open]="layout.state.navbarOpen" >
  <a class="nav-link clickable">
    <ng-content></ng-content>
  </a>
</li>
</ul>
</nav>